import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import LanguageSwitch from '../LanguageSwitch/LanguageSwitch';
import LoginButton from '../LoginButton/LoginButton';
import Navigation from '../Navigation/Navigation';
import { HamburgerBar, HamburgerMenu, LoginWrapper, StyledCloseIcon, Wrapper } from './HeaderNav.styles';

const HeaderNav = ({ languageSwitch, navigation, navIsOpen, setNavIsOpen }) => {
  const { t } = useTranslation('common');
  return (
    <>
      <Wrapper>
        <LoginWrapper>
          <LanguageSwitch languages={languageSwitch} />
          <LoginButton cta={`${t('general.login')}`} half />
        </LoginWrapper>

        <HamburgerMenu navIsOpen={navIsOpen} onClick={() => setNavIsOpen(!navIsOpen)}>
          {navIsOpen ? (
            <StyledCloseIcon />
          ) : (
            <div>
              <HamburgerBar />
              <HamburgerBar />
              <HamburgerBar />
            </div>
          )}
        </HamburgerMenu>
      </Wrapper>
      {navigation && (
        <Navigation
          languageSwitch={languageSwitch}
          navigation={navigation}
          navIsOpen={navIsOpen}
          setNavIsOpen={setNavIsOpen}
        />
      )}
    </>
  );
};

export default HeaderNav;
